'use client';

import ScheduleFilterMobile from 'app/components/common/schedule/ScheduleFilterMobile';
import WithMediaQuery from 'app/components/common/WithMediaQuery';
import { IScheduleFilterFormFields } from 'app/components/common/schedule/ScheduleFilter';

interface IProps {
  initialState: IScheduleFilterFormFields;
  theme?: 'white' | 'brown';
}

export default function ScheduleFilterMobileRender({
  initialState,
  theme = 'white'
}: IProps) {
  return (
    <WithMediaQuery>
      {({ isScreen_md }) =>
        !isScreen_md && (
          <ScheduleFilterMobile initialState={initialState} theme={theme} />
        )
      }
    </WithMediaQuery>
  );
}
